module.exports = __webpack_public_path__ + "img/stema.c8b7c6ea.jpg";